import gql from 'graphql-tag';

export default gql`
  mutation requestPhoneNumberVerification($userLoginId: UUID!, $phoneNumber: String) {
    requestPhoneNumberVerification(userLoginId: $userLoginId, phoneNumber: $phoneNumber)
  }
`;
